module.exports = __webpack_public_path__ + "img/404-Illustration@3x.8ee408fd.png";